module.exports = __webpack_public_path__ + "img/7minutos.731b08dd.jpg";